import getDataLayer from './getDataLayer';
import { getOwnCategory } from '../getOwnCategory';
import { DL_CURRENCY, DlEcommerceEvents, DlEventSource } from './constant';
import { IProduct } from '../../typings/IProduct';

export const DL_ViewItemList = (products: IProduct[], dlEventSource: DlEventSource, indexFrom = 0) => {
  const dlItems = products.map((product: IProduct, currentIndex: number) => {
    const customCategory = getOwnCategory(product?.customCategories);
    return {
      item_name: product?.titleDe || product?.title,
      item_id: product?.id,
      item_category: customCategory?.name,
      item_brand: product?.brand?.nameDe,
      price: product?.productOptions[0]?.salePrice || product?.productOptions[0]?.price,
      index: indexFrom + currentIndex,
    };
  });
  getDataLayer().push({
    event: DlEcommerceEvents.VIEW_ITEM_LIST,
    ecommerce: {
      currency: DL_CURRENCY,
      item_list_id: dlEventSource.id,
      item_list_name: dlEventSource.name,
      items: dlItems,
    },
  });
};
